import {ErrorHandler, Injectable, Injector, NgZone} from "@angular/core";
import {DxLogger} from "./dx-logger.service";
import {DxErrorService} from "./dx-error.service";


/**
 *  Глобальный обработчик ошибок приложения.
 *  Является единым местом обработки ошибок, не обработанных локально.
 *  @publicApi
 */
@Injectable()
export class DxErrorHandler implements ErrorHandler {
  /**
   * Логгер.
   * @name _logger
   * @type {DxLogger}
   */
  private _logger: DxLogger;

  /**
   * Сервис для работы с ошибками.
   * @name _errorService
   * @type {DxErrorService}
   */
  private _errorService: DxErrorService;


  /**
   * Создает инстанс сервиса-перехватчика ошибок.
   *
   * Нюанс в том, что обработка ошибок должна загружаться самой первой.
   * Поэтому использовать DI для получения зависимостей тут нельзя.
   * setTimeout - немного магии за пределами Хогвардс :)
   * Проблему так и не решили. При попытке инжектирования Router в наследника ErrorHandler
   * происходит ошибка зацикливания инжектора. Причем проблема остается даже если вынести все в отдельный сервис.
   *
   * @constructor
   * @param {Injector} _injector - инжектор.
   */
  constructor(private _injector: Injector, private _ngZone: NgZone) {
    setTimeout(() => {
      this._logger = this._injector.get(DxLogger);
      this._errorService = this._injector.get(DxErrorService);
    });
  }

  /**
   *  Диспетчерезирует обработку всех ошбок, не обработанные локально.
   *  Таким образом `throw new Error('Ошибка')` будет перехвачен методом `handleError(error: any)`.
   */
  handleError(error: Error): void {
    if (error.message.includes('ExpressionChangedAfterItHasBeenCheckedError') &&
      error.message.includes('tabindex:')) {
      console.warn('unhandled error:', error);
      return;
    }
    console.error('unhandled error:', error);
    // Так как перехват ошибки это программное действие и не связано с
    // действиями пользователя на интерфэйсе, необходимо обернуть выполнение
    // в вызов запуска жиненого цикла ангуляра для корректного детектирования изменений.
    // this._ngZone.run(() => {
    //   const dxError = DxErrorService.buildDxAppError(error);
    //   this._errorService.lastError = dxError;
    //   this._logger.error(dxError.message + ' ' + dxError.stackTrace);
    //   //this._errorService.redirectToErrorPage();
    // });
  }
}
